module.exports = __webpack_public_path__ + "static/media/sterling.3f5add86.png";